module.exports = __webpack_public_path__ + "static/all@2x-5d5e0ea86ed54e9a963b2ff72b97187f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/devices/all@2x.png
// module id = 918
// module chunks = 115276404313086 271422636699454